import React from 'react';
import { Box, Typography, FormControlLabel, Switch } from '@mui/material';

const NATIVE_TOOLS_BY_PROVIDER = {
  gemini: [
    {
      key: 'google_search',
      label: 'Google Search Grounding',
      description: 'Gemini busca en Google antes de responder. Ideal para info actual del mercado, tendencias y competencia.'
    }
  ]
};

function AgentFormNativeTools({ providerAi, extraParameters, onExtraParametersChange }) {
  const provider = providerAi?.toLowerCase();
  const tools = NATIVE_TOOLS_BY_PROVIDER[provider] || [];

  if (tools.length === 0) {
    return (
      <Box>
        <Typography variant="body2" color="text.secondary">
          No hay herramientas nativas disponibles para {providerAi || 'el provider seleccionado'}.
        </Typography>
      </Box>
    );
  }

  const handleToggle = (key) => {
    const current = extraParameters[key];
    const newValue = current === 'true' ? 'false' : 'true';
    onExtraParametersChange({ ...extraParameters, [key]: newValue });
  };

  return (
    <Box>
      {tools.map(tool => (
        <Box key={tool.key} sx={{ mb: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={extraParameters[tool.key] === 'true'}
                onChange={() => handleToggle(tool.key)}
              />
            }
            label={tool.label}
          />
          <Typography variant="caption" color="text.secondary" display="block" sx={{ ml: 6, mt: -0.5 }}>
            {tool.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default AgentFormNativeTools;
